import titleCaseString from "../../../../utils/titleCaseUtils";
import { useAuth } from "../../../../contexts/AuthContext";
// import ImageCapture from "../../../../components/ImageCapture";
import ImageCaptureMinimal from "../../../../components/ImageCaptureMinimal";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';


// CSS
import "../../../../styles/imagezoom.css";
import ImageHoverPopup from "../../../../components/ImageHoverPopup";


// PDF
/* PDF VIEWER */
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import the zoom plugin
import { zoomPlugin } from '@react-pdf-viewer/zoom';


/* CSS PDF VIEWER */
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


const Page3 = ({ formData,setFormData, saveData, prevPage,showSaveButton }) => {
    const zoomPluginInstance = zoomPlugin();
     const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
  
console.log("ssda",formData);

 const [pdfUrl, setPdfUrl] = useState(null);
    useEffect(() => {
        if (formData.scannedImages && formData.scannedImages.type === "application/pdf") {
            const url = URL.createObjectURL(formData.scannedImages);
            setPdfUrl(url);
            return () => URL.revokeObjectURL(url);
        }
    }, [formData.scannedImages]);




 const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: () => null, // Disable the toolbar completely
  });

  const navigate       = useNavigate();
  const { user }       = useAuth();
  const lawyerId       = user.user_id;
  const lawyerPhoto    = user.user_profile_photo
  const lawyerFullName = `${user.first_name} ${user.middle_name ?? ""} ${user.last_name}`;
 

  const DateFormatter = ({ date }) => {
    const formatDate = (date) => {
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
  
      // Format the date without the time
      return new Date(date).toLocaleDateString('en-US', options);
    };
  
    return <div>{formatDate(date)}</div>;
  };

const handleImageChange = (image,keyName) => {
    setFormData({ ...formData, [keyName]: image });
};

const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const gotoDashboard =()=>{
    navigate('/certificates/');
  }



// lawyerImageNotary
// lawyerImageNotarySignature


// lawyerFirstName
// lawyerMiddleName
// lawyerLastName
// lawyerSuffix
// lawyerBirthday
// lawyerPlaceOfBirth
// lawyerGender
// lawyerCivilStatus
// lawyerCountry
// region
// province
// cityMunicipality
// barangay

// lawyerContactNumber
// lawyerEmail


// PAGE 2
// lawyerNotaryName
// lawyerNotaryRollNo
// lawyerCommissionNo
// lawyerCommissionExpiryDate
// lawyerPTRNo
// lawyerPTRDateIssued
// lawyerPTRPlaceOfIssue
// lawyerIBPNo
// lawyerComplianceNo
// lawyerComplianceDateIssued
// lawyerNotarialEmail
// lawyerNotarialAddress

// uploadedFiles



  return (
    <div className="step-content">
      <div>
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <div className="d-flex flex-column justify-content-center">
            <h4 className="mb-1 mt-3">REVIEW INFORMATION</h4>
            <p className="text-muted">check your data before saving</p>
          </div>
        </div>
          
  
            <div className="row">

              <div className="col-12 mb-md-0 mb-4">
                <div className="card shadow-none">
                  {/* PAGE 1 */}
                  <div className="card-body p-0">
                    <div className="row">



                      <div className="col-md-12">
                        <table className="table table-bordered" style={{borderRadius:10}}>
                          <tbody>
 
                        {formData.lawyerImageNotary &&
                        
                          <tr className="">
                            <td className="fw-bold p-0 " colSpan={2} >


                              <img
                                className="w-100 bg-dark"
                                src={
                                  typeof formData.lawyerImageNotary === 'string' &&
                                    formData.lawyerImageNotary.startsWith('data:image/')
                                    ? formData.lawyerImageNotary // ✅ base64
                                    : formData.lawyerImageNotary instanceof File
                                      ? URL.createObjectURL(formData.lawyerImageNotary) // ✅ File object
                                      : ''
                                }
                                alt="Preview"
                                style={{
                                  minWidth: "33%",
                                  height: "auto",
                                  objectFit: "cover",
                                  transform: 'scaleX(-1)'
                                }}
                              />


                            </td>
                          </tr>
                        }


                        {formData.lawyerImageNotarySignature &&
                          <tr>
                            <td className="fw-bold p-0" colSpan={2}  >
                              <img src={formData.lawyerImageNotarySignature}

                                alt={`Signature`} height={100} width={25} className="card-img-top rounded-0" />
                            </td>
                          </tr>
                        }


                            
                            <tr>
                              <td className="pe-3"><i className="bx bx-user" /><span className="fw-medium mx-2">First:</span></td>
                              <td className="fw-bold">{formData.lawyerFirstName?.toUpperCase()}</td>


                            
                            </tr>


                            <tr>
                              <td className="pe-3"><i className="bx bx-user" /><span className="fw-medium mx-2">Middle:</span></td>
                              <td className="fw-bold">{formData.lawyerMiddleName?.toUpperCase()}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-user" /><span className="fw-medium mx-2">Last:</span></td>
                              <td className="fw-bold">{formData.lawyerLastName?.toUpperCase()}</td>
                            </tr>
                            
                            <tr>
                              <td className="pe-3"><i className="bx bx-user" /><span className="fw-medium mx-2">Suffix:</span></td>
                              <td className="fw-bold">{formData.lawyerSuffix?.toUpperCase()}</td>
                            </tr>
                         

                            <tr>
                              <td className="pe-3"><i className="bx bx-calendar" /><span className="fw-medium mx-2">Birthday:</span></td>
                              <td className="fw-bold">{<DateFormatter date={formData.lawyerBirthday?.toString() ?? ''} />}</td>
                            </tr>
 
                            <tr>
                              <td className="pe-3"><i className="bx bx-current-location" /><span className="fw-medium mx-2">Birthplace:</span></td>
                              <td className="fw-bold">{formData.lawyerPlaceOfBirth?.toUpperCase()}</td>
                            </tr>


                      

                         

                            <tr height={57}>
                              <td className="pe-3"><i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span></td>
                              <td className="fw-bold">{formData.lawyerGender?.toUpperCase()}</td>
                            </tr>
                            <tr height={57}>
                              <td className="pe-3"><i className="bx bx-group" /><span className="fw-medium mx-2">Civil Status:</span></td>
                              <td className="fw-bold">{formData.lawyerCivilStatus?.toUpperCase()}</td>
                            </tr>



                     



                            <tr>
                              <td className="ps-0 border-0" colSpan={2}>
                                <h5 className="my-2">Lawyer Address</h5>
                              </td>
                            </tr>





                            <tr height={57}>
                              <td className="pe-3"><i className="bx bx-map-pin" /><span className="fw-medium mx-2">Country:</span></td>
                              <td className="fw-bold" colSpan={2}>{formData.country?.toUpperCase()}</td>
                            </tr>
                            <tr height={57}>
                              <td className="pe-3"><i className="bx bx-map-pin" /><span className="fw-medium mx-2">Region:</span></td>
                              <td className="fw-bold" colSpan={2}>{formData.region?.toUpperCase()}</td>
                            </tr>
                            <tr height={57}>
                              <td className="pe-3"><i className="bx bx-map-pin" /><span className="fw-medium mx-2">Province:</span></td>
                              <td className="fw-bold" colSpan={2}>{formData.province?.toUpperCase()}</td>
                            </tr>
                            <tr height={57}>
                              <td className="pe-3"><i className="bx bx-map-pin" /><span className="fw-medium mx-2">City / Mun:</span></td>
                              <td className="fw-bold" colSpan={2}>{formData.cityMunicipality?.toUpperCase()}</td>
                            </tr>
                            <tr height={57}>
                              <td className="pe-3"><i className="bx bx-map-pin" /><span className="fw-medium mx-2">Barangay:</span></td>
                              <td className="fw-bold" colSpan={2}>{formData.barangay?.toUpperCase()}</td>
                            </tr>
                            



                    

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  

                  {/* PAGE 2 - Uploaded Documents / Requirements */}
                  <div className="card-body d-none">
                    <div className="row">
                      <h4 className="bg-label-primary py-2 mx-0 rounded">Scanned & Uploaded Documents</h4>
                      <div className="col-md-12">
                       <div className="row d-flex justify-content-center align-items-start border rounded mx-1" style={{ maxHeight: 300, overflowY: "scroll", minHeight: 365 }}>


                        <div className="row my-4" style={{ maxHeight: 500, overflowY: "auto" }}>
                          {formData.uploadedFiles.map((file, index) => {
                            const previewUrl = URL.createObjectURL(file);
                            const isImage = file.type.startsWith("image/");
                            const isPDF = file.type === "application/pdf";
                            // const baseName = customNames[index] || file.name.replace(/\.[^/.]+$/, "");

                            return (
                              <div key={index} className="col-md-3 mb-4">
                                <div className="card shadow-none h-100">
                                  <div className="card-body d-flex flex-column">
                                    <h6 className="card-title">File {index + 1}</h6>

                                    {isImage && (
                                      <img
                                        src={previewUrl}
                                        alt={`Preview ${index}`}
                                        className="img-fluid mb-2 rounded w-100"
                                        style={{ maxHeight: 242, height: 242 }}
                                      />
                                    )}

                                    {isPDF && (
                                      <div className="pdf-viewer" style={{ height: 242, maxHeight: 242 }}>
                                        <Worker workerUrl="../../js/pdf.worker.min.js">
                                          <div className="mb-2 d-flex col-12 justify-content-center p-0">
                                            <ZoomOutButton />
                                            <ZoomPopover />
                                            <ZoomInButton />
                                          </div>
                                          <Viewer
                                            fileUrl={previewUrl}
                                            plugins={[zoomPluginInstance]}
                                          />
                                        </Worker>
                                      </div>
                                    )}
                              
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                       
                         
                        
                       </div>
                      </div>




                    </div>
                  </div>

 
                 
 


                 
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <span className="fw-medium">Note: </span>
                        <span>
                          Please make sure you encoded the correct information before proceeding. Once you proceed, you cannot edit the information anymore.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Invoice */}

            </div>


      </div>
      {showSaveButton &&
        <div className="col-12 d-flex justify-content-between">
          <button className="btn btn-label-secondary btn-prev" onClick={prevPage}>
            <i className="bx bx-chevron-left bx-sm ms-sm-n2" />
            <span className="align-middle d-sm-inline-block d-none">
              Previous
            </span>
          </button>
          <button className="btn btn-primary btn-next" onClick={saveData}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              Save
            </span>
            <i className="bx bx-save bx-sm me-sm-n2" />
          </button>
        </div>
      }

{/* {!showSaveButton &&
        <div className="col-12 d-flex justify-content-end">
          
          <button className="btn btn-primary btn-next" onClick={gotoDashboard}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              End Transaction
            </span>
            <i className="bx bx-save bx-sm me-sm-n2" />
          </button>
        </div>
      } */}

    </div>
  );
};

export default Page3;
